<template>
    <div id="app">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-3">
                    <div class="admin-menu">
                        <img src="https://boonb.s3.amazonaws.com/law/boon-logo.svg" alt="boon" class="brand"/>
                        <nav class="navbar-light bg-light main-navbar">
                            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#mainmenu" aria-controls="mainmenu" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                            </button>
                        </nav>
                        <div class="collapse show" id="mainmenu">
                            <ul>
                                <template v-if="$store.getters.isLoggedIn">
                                    <div v-if="$store.getters.isBaseActionsGranted">
                                        <li>
                                            <router-link class="nav-link" :class="{'active': isActive('home')}" :to="{name: 'home'}">
                                                <i class="fa fa-power-off prev-icon"></i> <span class="title">Dashboard</span> <span class="arrow-menu">></span>
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" :class="{'active': isActive('subscription')}" :to="{name: 'admin.subscription'}">
                                                <i class="fa fa-building prev-icon"></i> <span class="title">Subscriptions</span> <span class="arrow-menu">></span>
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" :class="{'active': isActive('driver')}" :to="{name: 'admin.driver'}">
                                                <i class="fa fa-id-card prev-icon"></i> <span class="title">Drivers</span> <span class="arrow-menu">></span>
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" :class="{'active': isActive('wallet')}" :to="{name: 'admin.wallet.client'}">
                                                <i class="fa fa-suitcase prev-icon"></i> <span class="title">Wallet Clients</span> <span class="arrow-menu">></span>
                                            </router-link>
                                        </li>
                                    </div>
                                    <div v-if="$store.getters.isWalletAccessGranted">
                                        <test-mode></test-mode>
                                        <li class="nav-item">
                                            <router-link class="nav-link" :class="{'active': isActive('project_wallet.view')}" :to="{name: 'admin.project_wallet.view'}">
                                                <i class="fa fa-suitcase prev-icon"></i> <span class="title">Project Wallet</span> <span class="arrow-menu">></span>
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" :class="{'active': isActive('client')}" :to="{name: 'admin.project_wallet.client'}">
                                                <i class="fa fa-users prev-icon"></i> <span class="title">Wallet Clients</span> <span class="arrow-menu">></span>
                                            </router-link>
                                        </li>
                                        <li class="nav-item">
                                            <router-link class="nav-link" :class="{'active': isActive('app.settings')}" :to="{name: 'admin.app.settings'}">
                                                <i class="fa fa-wrench prev-icon"></i> <span class="title">Settings</span> <span class="arrow-menu">></span>
                                            </router-link>
                                        </li>
                                    </div>
                                </template>
                                <template v-else>
                                    <li class="nav-item">
                                        <router-link class="nav-link" :to="{name: 'login'}">Log In</router-link>
                                    </li>
                                    <li class="nav-item">
                                        <router-link class="nav-link" :to="{name: 'signup'}">Sign Up</router-link>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="col-md-9 main-content">
                    <main role="main">
                        <div class="left-dd-menu" v-if="$store.getters.isLoggedIn">
                            <b-dropdown>
                                <div slot="button-content">
                                    <img src="https://boonb.s3.amazonaws.com/law/person.png" alt="person"/>
                                </div>
                                <b-dropdown-item @click.prevent.stop="logout">Logout</b-dropdown-item>
                            </b-dropdown>
                        </div>
                        <div class="container-fluid">
                            <router-view/>
                        </div>
                    </main>
                </div>
            </div>
        </div>
        <footer class="footer mt-auto py-3">
            <div class="container text-center">

            </div>
        </footer>
    </div>
</template>

<script>
import TestMode from "@/components/admin/wallet/TestMode";
export default {
    data() {
        return {
            showLogout: false
        }
    },
    components: {'test-mode': TestMode},
    methods: {
        logout() {
            this.$store.dispatch('logout')
                .then(() => {
                    this.$router.push({name: 'login'});
                })
        },
        isActive(str) {
            return this.$router.currentRoute.name ? this.$router.currentRoute.name.includes(str) : false;
        }
    },
    mounted() {
    }
}
</script>

<style lang="scss">
@import "assets/scss/app";
</style>
